import React, { useContext, useEffect, useState, FC } from "react";
import { toast } from 'react-toastify';
import axios, { AxiosResponse } from "axios";
import { Button, Dropdown, Checkbox, Dimmer, Loader } from "semantic-ui-react";
import { AdminContext } from "../../contexts/AdminContext";
import AuthContext from "../../contexts/AuthContext";
import { getRequest, postRequest } from "../../services/axiosService";
import { DropdownOptionNumerical } from "../Interfaces/AdminInterface";

export const enum SchedulerTypes {
    None = 0,
    Daily = 1,
    Weekly = 2,
    Monthly = 3
}

const SchedulerOptions: DropdownOptionNumerical[] = [
    { key: SchedulerTypes.None, value: SchedulerTypes.None, text: "None" },
    { key: SchedulerTypes.Daily, value: SchedulerTypes.Daily, text: "1 Day" },
    { key: SchedulerTypes.Weekly, value: SchedulerTypes.Weekly, text: "1 Week" },
    { key: SchedulerTypes.Monthly, value: SchedulerTypes.Monthly, text: "1 Month" },
]

function LogSettings() {

    const [schedulerFrequency, setSchedulerFrequency] = useState<SchedulerTypes>(SchedulerTypes.None);
    const [logDeletion, setLogDeletion] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    const { logSettings, setLogSettings } = useContext(AdminContext);
    const { auth } = useContext(AuthContext);


    useEffect(() => {
        getSettings();

    }, []);

    const getSettings = () => {

        setSchedulerFrequency(logSettings.schedulerFrequency);
        setLogDeletion(logSettings.logDeletion);
    };

    const saveSettings = async () => {
        setLoading(true);

        try {
            let newSettings = {
                schedulerFrequency: schedulerFrequency,
                logDeletion: logDeletion
            };
            let response: AxiosResponse = await postRequest(auth, `/Admin/SaveLogSettings`, newSettings);
            if (response) {
                setLogSettings(newSettings);
                toast.success("Settings saved");
            }
        } catch (e) {
            console.log(e.response);
            toast.error(`Unable to save settings`);
        }

        setLoading(false);
    };

    const runNow = async () => {
        setLoading(true);
        try {
            const response = await getRequest(auth, "/Admin/RunLogDeletion");
            toast.success(`Log deletion/compression started`);
        } catch (error) {
            console.log(error);
            toast.error(`Unable to run log deletion/compression`);
        }
        setLoading(false);
    };

    if (loading) {
        return (
            <Dimmer inverted active={true}>
                <Loader inverted>Loading Log Settings...</Loader>
            </Dimmer>
        )

    }
    else {
        return (
            <div className="ui admin-container" style={{ borderBottom: "0" }} id="admin-container">
                <div className="header blue headerStyleBlue">Log File Management</div>

                <div className="header gray headerStyleGray">SCHEDULER FREQUENCY</div>
                <div className="meta" style={{ marginLeft: 10 }}> Logs older than the selected time span will be compressed/deleted</div>
                <Dropdown id="log-freq" placeholder='Select Scheduler Frequency' style={{ marginLeft: '10px', backgroundColor: "#e5e5e5" }} fluid
                    selection options={SchedulerOptions} value={schedulerFrequency} onChange={(e, { value }) => { setSchedulerFrequency(value as SchedulerTypes); }} />

                <div className="header gray headerStyleGray" style={{ marginTop: 10 }}>LOG DELETION</div>
                <Checkbox toggle label="Delete Logs" checked={logDeletion} onChange={(e: any, data: any) => setLogDeletion(data.checked as boolean)} style={{ marginLeft: '10px', marginBottom: 10 }} />
                <br />
                <Checkbox toggle label="Compress Logs" checked={!logDeletion} onChange={(e: any, data: any) => setLogDeletion(!logDeletion)} style={{ marginLeft: '10px' }} />

                <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "left", alignContent: "stretch", margin: 10 }}>
                    <input id="general-save" className="ui button" style={{ marginTop: 20 }} type="submit" onClick={saveSettings} value="Save" />
                    <input id="general-cancel" className="ui button" style={{ marginTop: 20, marginLeft: 5 }} type="submit" onClick={getSettings} value="Cancel" />
                    <input id="run-now" className="ui button" style={{ marginTop: 20, marginLeft: 5 }} type="submit" onClick={runNow} value="Run Now" />
                </div>
            </div>
        );
    }

}


export default LogSettings;